const destinationList = {
    'jm': {
        destination: 'Jamaica',
        img: 'jamaica',
        subtitle: 'There is a magic to the island of Jamaica',
        description: '<span>The beaches in Jamaica are truly spectacular,</span> from secluded private coves to Negril\'s world-renowned seven-mile stretch of powdery white sand, all looking out onto the ultra-clear, turquoise waters of the Caribbean.</p>',
        resorts: [
            {
                resortName: 'Montego Bay',
                city: 'Montego Bay',
                code: 'smb',
                description: 'Ultimate tranquility within reach on Jamaica\’s best beautifully private seafront.',
                resortLink: '/en/montego-bay/'
            },
            {
                resortName: 'Negril',
                city: 'Negril',
                code: 'sng',
                description: 'On the best stretch of Negril\'s famed 7-mile white sand beach.',
                resortLink: '/en/negril/'
            },
            {
                resortName: 'Royal Caribbean',
                city: 'Montego Bay',
                code: 'src',
                description: 'A quaint cove beach parallel to the resort plus a private offshore island beach.',
                resortLink: '/en/royal-caribbean/'
            },
            {
                resortName: 'Ochi',
                city: 'Ocho Rios',
                code: 'sgo',
                description: 'Waterside drinks and spirits at a private cove beach or exclusive Ochi Beach Club.',
                resortLink: '/en/ochi/'
            },
            {
                resortName: 'Royal Plantation',
                city: 'Ocho Rios',
                code: 'srp',
                description: 'On two of Jamaica’s most tranquil private cove beaches',
                resortLink: '/en/ochi/'
            },
            {
                resortName: 'South Coast',
                city: 'Whitehouse',
                code: 'swh',
                description: 'A two-mile unspoiled white-sand beach that extends into a nature preserve.',
                resortLink: '/en/south-coast/'
            }
        ]
    },
    'ba': {
        destination: 'Bahamas',
        img: 'bahamas',
        subtitle: 'Paradise is just minutes away from the U.S. Coastline',
        description: '<span>Endless crystal turquoise water</span> beguiles the senses and invites you to explore vibrant coral reefs beneath its surface in this quintessential island paradise.</p>',
        resorts: [
            {
                resortName: 'Royal Bahamian',
                city: 'Nassau',
                code: 'srb',
                description: 'A three-in-one beach experience &ndash; one private beach cove and two white sand beaches on an offshore island.',
                resortLink: '/en/royal-bahamian/'
            }
        ]
    },
    'an': {
        destination: 'Antigua',
        img: 'antigua',
        subtitle: 'Remarkable Natural Bounty',
        description: '<span>Famous all over the world for its 365 spectacular beaches,</span> with sand so pure it casts a pinkish hue and the clearest, aqua–blue waters imaginable, make Antigua one of the most priceless gems in the Caribbean.</p>',
        resorts: [
            {
                resortName: 'Grande Antigua',
                city: 'St. John\'s',
                code: 'sat',
                description: 'The island of Antigua boasts 365 beaches and Sandals Grande Antigua is located on the best on them all!',
                resortLink: '/en/grande-antigua/'
            }
        ]
    },
    'lu': {
        destination: 'Saint Lucia',
        img: 'lucia',
        subtitle: 'Exotic Paradise beyond compare',
        description: '<span>Saint Lucia\'s exotic beauty truly captures the luxuriant allure of the Caribbean.</span> From the distinctive twin peaks of Les Pitons to the cascading majesty of Diamond Falls and the translucent turquoise sea that frames it all, Saint Lucia dazzles the eye as it seduces the body and spirit.</p>',
        resorts: [
            {
                resortName: 'Regency La Toc',
                city: 'Castries',
                code: 'slu',
                description: 'Perfect setting for rest and romance on a private cove beach bathed in sunshine and lush foliage.',
                resortLink: '/en/regency-la-toc/'
            },
            {
                resortName: 'Grande St. Lucian',
                city: 'Gros Islet',
                code: 'sgl',
                description: 'Sunrises and sunsets leave colorful imprints on the surrounding mountains and bay-facing beach.',
                resortLink: '/en/grande-st-lucian/'
            },
            {
                resortName: 'Halcyon Beach',
                city: 'Castries',
                code: 'shc',
                description: 'An idyllic escape with a long stretch of beach and restful ocean.',
                resortLink: '/en/halcyon-beach/'
            }
        ]
    },
    'gr': {
        destination: 'Grenada',
        img: 'grenada',
        subtitle: 'The most alluring destination in the caribbean',
        description: '<span>An exotic, unspoiled hideaway.</span> Home to both black sand and white sand beaches with water so blue and clear that coral formations can be spotted from the air, Grenada\'s volcanic origin has created a landscape of great beauty and variety.</p>',
        resorts: [
            {
                resortName: 'Grenada',
                city: 'St. George\'s',
                code: 'sls',
                description: 'A private cove beach with unforgettable panoramas of the charming hillside and glittering sea.',
                resortLink: '/en/grenada/'
            }
        ]
    },
    'bd': {
        destination: 'Barbados',
        img: 'barbados',
        subtitle: 'A jewel of natural beauty',
        description: '<span>Discover the vibrancy and charm of a lively destination,</span> A bustling South Coast hotspot comprised of a stunning beachfront, colorful nightlife, and superb restaurants and lounges.</p>',
        resorts: [
            {
                resortName: 'Barbados',
                city: 'St. Lawrence Gap',
                code: 'sbd',
                description: 'Endless vistas from the comfort of beach chairs or a magnificent beachfront whirlpool just off the shore.',
                resortLink: '/en/sandals-barbados/'
            },
            {
                resortName: 'Royal Barbados',
                city: 'St. Lawrence Gap',
                code: 'sbr',
                description: 'Experience the royal treatment at the all-new, all-suite resort, all on a jet-setter destination.',
                resortLink: '/en/royal-barbados/'
            }
        ]
    }
};

module.exports = destinationList;
